import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./Dropdown_CardResolution.css";
import { renderSettingsOptions } from "../../Pages/ProjectV2/Render/render.constants";

const Dropdown_CardResolution = ({ label, setResolution }) => {
  const [displayValue, setDisplayValue] = useState("Select an option");
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const freeRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
      (resolutionType) => {
        return { label: resolutionType, value: resolutionType };
      }
    );
    setOptions(freeRenderSettingsOptions);
  }, []);

  const handleSelected = (value) => {
    setResolution(value);
    setDisplayValue(value);
    setIsOptionsVisible(false);
  };

  const dropdownOptions = (
    <div className="cardDropdown-options">
      {options?.map((option, ind) => (
        <div
          key={ind}
          className="cardDropdown-renderList-1"
          onClick={() => handleSelected(option.value)}
        >
          <div className="cardDropdown-label-render">
            <div className="flex">{option.label}</div>
          </div>
          <hr className="cardDropdown-hr" />
        </div>
      ))}
    </div>
  );

  return (
    <div className="cardDropdown">
      {label && <span className="cardDropdown-label">{label}</span>}

      <div
        className="cardDropdown-component"
        onClick={() => setIsOptionsVisible((prev) => !prev)}
      >
        <div className="cardselected-options-wrapper">
          <div className="icon-box02">
            {isOptionsVisible ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-chevron-up"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24V24H0z" fill="none" />
                <polyline points="6 15 12 9 18 15" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-chevron-down"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24V24H0z" fill="none" />
                <polyline points="6 9 12 15 18 9" />
              </svg>
            )}
          </div>
          <hr />
          <div className="cardDropdown-selected">{displayValue}</div>
        </div>
      </div>

      {/* Render dropdown options using React Portal */}
      {isOptionsVisible &&
        ReactDOM.createPortal(
          dropdownOptions,
          document.getElementById("dropdown-root") // Target a root outside the modal
        )}
    </div>
  );
};

export default Dropdown_CardResolution;
